import * as Actions from './custom-dashboard-content.actions';
import { ICustomDashboardContentState } from './custom-dashboard-content.model';
import { ELoadStatus } from '../../../../constants.model';

export const customDashboardContentState: ICustomDashboardContentState = {
  isSqcdpDateFilterVisible: false,
  customDashboardContents: null,
  customDashboardContentsLoadStatus: ELoadStatus.Initial,
  unplannedDownTimeActivityColor: null,
  sqcdpFilter: null,
};

export function customDashboardContentReducer(
  state: ICustomDashboardContentState = customDashboardContentState,
  action: Actions.TCustomDashboardContentActions,
): ICustomDashboardContentState {
  switch (action.type) {
    case Actions.CustomDashboardContentActionTypes.FetchCustomDashboardContents:
      return {
        ...state,
        customDashboardContentsLoadStatus: ELoadStatus.Loading,
      };
    case Actions.CustomDashboardContentActionTypes.FetchCustomDashboardContentsCompleted:
      return {
        ...state,
        customDashboardContentsLoadStatus: ELoadStatus.Success,
        customDashboardContents: action.payload.customDashboardContents,
        unplannedDownTimeActivityColor: action.payload.unplannedDownTimeActivityColor,
      };
    case Actions.CustomDashboardContentActionTypes.SetIsSqcdpDateFilterVisible:
      return {
        ...state,
        isSqcdpDateFilterVisible: action.isVisible,
      };
    case Actions.CustomDashboardContentActionTypes.SetSqcdpDateFilter:
      return {
        ...state,
        sqcdpFilter: {
          ...state.sqcdpFilter,
          year: action.year,
          month: action.month,
        },
      };
      case Actions.CustomDashboardContentActionTypes.SetSqcdpDay:
      return {
        ...state,
        sqcdpFilter: {
          ...state.sqcdpFilter,
          day: action.day,
        },
      };
    default:
      return state;
  }
}
